import TR from 'utils/TR';
import Segment from 'components/common/Segment';
import T from 'utils/T';
import ex from 'utils/ex';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function GMIBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    gmi,
  } = data || {};

  return (
    <Segment {...ex(['OverviewSummaryBox', 'GMIBox', 'normal'], rest)}>
      <div>
        {T('GMI')}
      </div>
      <div>
        <div {...ex(['BASE_COLOR', CHECK_COLORS('GMI', gmi)])}>
          {gmi}
        </div>
        <div>
          {T('%')}
        </div>
      </div>
    </Segment>
  );
}

